<template>
  <section class="banner-sobre">
    <div class="banner-container">
      <img src="../assets/banner-sobre.jpg" alt="Banner Sobre" class="banner-image" />
      <div class="banner-content">
        <p>A CATENA SYSTEM é uma empresa especializada em desenvolver soluções tecnológicas personalizadas, focadas em transformar os desafios dos nossos clientes em oportunidades de crescimento.</p>
        <p>Com uma equipe altamente qualificada, criamos sistemas e aplicativos que integram automação e inteligência, sempre com o objetivo de otimizar processos e gerar resultados eficientes.</p>
      </div>
    </div>
  </section>

  <section class="section-itens">
    <h2>CATENA SYSTEM</h2>
    <h1>Criada com o propósito de oferecer soluções de TI que realmente impactam o dia a dia das empresas</h1>
    <p>Desde o início, temos como foco oferecer tecnologia de ponta que se adapta às necessidades de cada cliente, garantindo que cada projeto entregue seja uma peça chave para o sucesso dos negócios.</p>
  </section>

  <section class="mission-vision-section">
    <div class="mission-vision-content">
      <div class="mission-item">
        <img src="../assets/missao.png" alt="Missão Icone" />
        <h3>Nossa Missão</h3>
        <p>Desenvolver soluções tecnológicas personalizadas que otimizem processos e automatizem operações, proporcionando inovação contínua para nossos clientes.</p>
      </div>
      <div class="vision-item">
        <img src="../assets/visao.png" alt="Visão Icone" />
        <h3>Nossa Visão</h3>
        <p>Ser referência em inovação e automação no mercado de software personalizado, sempre focando em entregar resultados eficientes e de alto impacto.</p>
      </div>
    </div>
    <div class="mission-vision-image">
      <img src="../assets/sobre-img-1.jpg" alt="Imagem Industrial" />
    </div>
  </section>

  <section class="section-itens">
    <div class="vision-item">
      <img src="../assets/valor.png" alt="Valores Icone" />
    </div>
    <h2>Nossos Valores</h2>
    <div class="section-grid">
      <div class="solution-item">
        <p>Inovação</p>
      </div>
      <div class="solution-item">
        <p>Eficiência</p>
      </div>
      <div class="solution-item">
        <p>Confiabilidade</p>
      </div>
      <div class="solution-item">
        <p>Foco no cliente</p>
      </div>
      <div class="solution-item">
        <p>
          Adaptabilidade para criar soluções <br />
          que acompanham as tendências tecnológicas
        </p>
      </div>
    </div>
    <div class="section-grid"></div>
  </section>

  <section class="clients-section">
    <h2>Nossos clientes</h2>
    <div class="clients-logos">
      <div class="client-logo">
        <img src="../assets/cliente-1.png" alt="Ministério Público de Minas Gerais" />
      </div>
      <div class="client-logo">
        <img src="../assets/cliente-2.png" alt="RoboFlex" />
      </div>
      <div class="client-logo">
        <img src="../assets/cliente-3.png" alt="Zontec" />
      </div>
      <div class="client-logo">
        <img src="../assets/cliente-4.png" alt="Zontec" />
      </div>
    </div>
  </section>

  <div class="banner-content-2">
    <p>Quer saber mais sobre como a CATENA SYSTEM pode transformar o seu negócio? Entre em contato e descubra como podemos ajudá-lo a alcançar seus objetivos!</p>

    <a href="https://wa.me/553189344230" target="_blank">
      <button class="cta-button">Fale conosco</button>
    </a>
  </div>

  <section class="contact-section">
    <div class="contact-content">
      <h2>Estamos prontos para transformar suas ideias em soluções tecnológicas eficientes. Entre em contato agora!</h2>
      <FormContatoVue />
    </div>
  </section>
</template>

<script>
import FormContatoVue from "@/components/FormContato.vue";

export default {
  components: {
    FormContatoVue,
  },
  name: "SobreComponent",
};
</script>

<style scoped>
.contact-section {
  background-color: #f5f5f5;
  padding: 40px 0;
  text-align: center;
}

.contact-content h2 {
  font-size: 1.8em;
  margin-bottom: 20px;
  margin-left: 300px;
  margin-right: 300px;
  color: #274862;
}

.banner-content-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #274862;
  color: white;
  padding: 60px;
  text-align: left;
}

.banner-content-2 p {
  font-weight: 600;
  padding-bottom: 30px;
}

.banner-2-p {
  flex: 1;
}

.banner-2-p p {
  line-height: 30px;
  font-size: 1.2em;
  margin-bottom: 20px;
  margin-right: 250px;
}

.cta-button {
  padding: 15px 30px;
  background-color: #9dee9c;
  border: none;
  color: #274862;
  font-size: 1em;
  cursor: pointer;
  border-radius: 5px;
  font-weight: 600;
  white-space: nowrap;
}

.cta-button:hover {
  background-color: #82c582;
}

.clients-section {
  text-align: center;
  padding: 50px 0;
}

.clients-section h2 {
  font-size: 2em;
  margin-bottom: 100px;
  color: #274862;
}

.clients-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 200px;
  flex-wrap: wrap;
}

.client-logo img {
  max-width: 200px;

  filter: grayscale(100%);
  transition: filter 0.3s ease-in-out, opacity 0.3s ease-in-out;
  opacity: 0.8;
}

.client-logo img:hover {
  filter: grayscale(0%);
  opacity: 1;
}

.mission-vision-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f5f5;
}

.mission-vision-content {
  flex: 1;
  padding-right: 50px;
}

.mission-item,
.vision-item {
  margin-bottom: 30px;
}

.mission-item img,
.vision-item img {
  width: 50px;
}

.mission-item h3,
.vision-item h3 {
  color: #274862;
  font-size: 1.5em;
}

.mission-item p,
.vision-item p {
  font-size: 1.1em;
  line-height: 1.6;
  color: #333;
}

.mission-vision-image {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.mission-vision-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-sobre {
  width: 100vw;
  height: 70vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-content {
  position: absolute;
  top: 50%;
  right: 10%;
  transform: translateY(-50%);
  background-color: rgba(39, 72, 98, 0.85);
  padding: 30px;
  max-width: 500px;
  text-align: left;
  border-radius: 10px;
}

.banner-content p {
  font-size: 1.1em;
  line-height: 1.6;
}

.solution-item p {
  font-weight: 600;
}

@media (max-width: 1024px) {
  .banner-content {
    max-width: 450px;
    padding: 25px;
  }

  .banner-content p {
    font-size: 1em;
  }

  .mission-vision-section {
    flex-direction: column;
    padding: 30px 40px;
  }

  .mission-vision-content {
    padding-right: 0;
    margin-bottom: 20px;
  }

  .mission-vision-image img {
    max-width: 100%;
  }

  .banner-content-2 {
    padding: 20px 40px;
    flex-direction: column;
    text-align: center;
  }

  .banner-2-p {
    margin-right: 0;
    max-width: 100%;
  }

  .clients-section h2 {
    font-size: 1.8em;
    margin-bottom: 50px;
  }

  .client-logo img {
    max-width: 120px;
  }

  .cta-button {
    padding: 12px 25px;
    font-size: 0.9em;
    width: 100%;
  }

  .contact-content h2 {
    margin: 0 50px;
  }
}

@media (max-width: 768px) {
  .banner-content {
    max-width: 90%;
    padding: 20px;
  }

  .banner-content p {
    font-size: 0.95em;
  }

  .mission-vision-section {
    flex-direction: column;
    padding: 20px 30px;
  }

  .banner-content-2 {
    flex-direction: column;
    padding: 20px;
    text-align: center;
  }

  .banner-2-p {
    margin-right: 0;
  }

  .clients-section h2 {
    font-size: 1.6em;
  }

  .client-logo img {
    max-width: 100px;
  }

  .cta-button {
    width: 100%;
    padding: 12px 20px;
  }

  .contact-content h2 {
    margin: 0 30px;
  }
}

@media (max-width: 480px) {
  .banner-sobre {
    height: 50vh;
  }

  .banner-content {
    max-width: 90%;
    padding: 15px;
  }

  .banner-content p {
    font-size: 0.85em;
  }

  .mission-vision-content {
    padding-right: 0;
  }

  .mission-item h3,
  .vision-item h3 {
    font-size: 1.2em;
  }

  .mission-item p,
  .vision-item p {
    font-size: 1em;
  }

  .clients-logos {
    display: flex;
    flex-direction: column;
  }
  .clients-logos {
    gap: 50px;
    flex-wrap: wrap;
  }
  .clients-section h2 {
    font-size: 1.4em;
    margin-bottom: 30px;
  }

  .banner-content-2 {
    background-color: #274862;
    color: white;

    text-align: center;
  }

  .banner-2-p {
    font-size: 1.2em;
  }

  .cta-button {
    padding: 10px 15px;
    font-size: 0.85em;
    width: 100%;
  }

  .contact-content h2 {
    font-size: 1.4em;
    margin: 0 20px;
  }
}
</style>
